import { render, staticRenderFns } from "./TemplateDataTile.vue?vue&type=template&id=7d3a85f8"
import script from "./TemplateDataTile.vue?vue&type=script&lang=js"
export * from "./TemplateDataTile.vue?vue&type=script&lang=js"
import style0 from "./TemplateDataTile.vue?vue&type=style&index=0&id=7d3a85f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports